import { FormatFieldItem } from "../../format-field-selector.types";

export type FormatsProps<Item extends FormatFieldItem> = {
  selectedFormat?: Item;
  formats: Array<Item>;
  loading: boolean;
  onSelectedFormatChange: (format: Item) => void;
  className?: string;
  classes?: {
    tableBody?: string;
  }
  moduleName?: string;
  tableColumns?: Array<{
    label:string,
    field: FormatColumnKey,
  }>;
  showTableHeader?: boolean
};

export enum FormatColumnKey {
  name = "name",
  description = "description",
}
